import DefaultLayout from "./DefaultLayout";

export default {
  install(Vue) {
    Vue.component("DefaultLayout", DefaultLayout);
  }
}